PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX body: <http://purl.obolibrary.org/obo/UBERON_0013702>
PREFIX hasExactSynonym: <http://www.geneontology.org/formats/oboInOwl#hasExactSynonym>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT DISTINCT ?root ?child ?parent ?label ?synonymLabel
FROM HRA:
WHERE {
  BIND(body: as ?root)

  {
    BIND(body: as ?child)
  }
  UNION
  {
    VALUES (?rank ?parent ?child) {
      # Body
      (1 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000955>)
      (2 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002182>)
      (3 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000970>)
      (4 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0003889>)
      (5 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000948>)
      (6 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002113>)
      (7 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001465>)
      (8 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000059>)
      (9 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001737>)
      (10 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002107>)
      (11 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002048>)
      (12 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000029>)
      (13 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000992>)
      (14 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001911>)
      (15 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002205>)
      (16 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000165>)
      (17 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002373>)
      (18 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001264>)
      (19 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001270>)
      (20 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001987>)
      (21 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002367>)
      (22 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001224>)
      (23 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002097>)
      (24 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002108>)
      (25 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002240>)
      (26 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000975>)
      (27 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002106>)
      (28 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0002370>)
      (29 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0003126>)
      (30 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000056>)
      (31 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0001255>)
      (32 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0000995>)
      (33 <http://purl.obolibrary.org/obo/UBERON_0013702> <http://purl.obolibrary.org/obo/UBERON_0004537>)
    }
  }
  UNION {
    VALUES (?parent ?child) {
      # Lymph Node
      (<http://purl.obolibrary.org/obo/UBERON_0000029> <http://purl.obolibrary.org/obo/UBERON_0002509>)
      # Eye
      (<http://purl.obolibrary.org/obo/UBERON_0000970> <http://purl.obolibrary.org/obo/UBERON_0004548>)
      (<http://purl.obolibrary.org/obo/UBERON_0000970> <http://purl.obolibrary.org/obo/UBERON_0004549>)
      # Fallopian Tube
      (<http://purl.obolibrary.org/obo/UBERON_0003889> <http://purl.obolibrary.org/obo/UBERON_0001303>)
      (<http://purl.obolibrary.org/obo/UBERON_0003889> <http://purl.obolibrary.org/obo/UBERON_0001302>)
      # Kidney
      (<http://purl.obolibrary.org/obo/UBERON_0002113> <http://purl.obolibrary.org/obo/UBERON_0004538>)
      (<http://purl.obolibrary.org/obo/UBERON_0002113> <http://purl.obolibrary.org/obo/UBERON_0004539>)
      # Knee
      (<http://purl.obolibrary.org/obo/UBERON_0001465> <http://purl.org/sig/ont/fma/fma24978>)
      (<http://purl.obolibrary.org/obo/UBERON_0001465> <http://purl.org/sig/ont/fma/fma24977>)
      # Mammary Gland
      (<http://purl.obolibrary.org/obo/UBERON_0001911> <http://purl.org/sig/ont/fma/fma57991>)
      (<http://purl.obolibrary.org/obo/UBERON_0001911> <http://purl.org/sig/ont/fma/fma57987>)
      # Ovary
      (<http://purl.obolibrary.org/obo/UBERON_0000992> <http://purl.obolibrary.org/obo/UBERON_0002119>)
      (<http://purl.obolibrary.org/obo/UBERON_0000992> <http://purl.obolibrary.org/obo/UBERON_0002118>)
      # Palatine Tonsil
      (<http://purl.obolibrary.org/obo/UBERON_0002373> <http://purl.org/sig/ont/fma/fma54974>)
      (<http://purl.obolibrary.org/obo/UBERON_0002373> <http://purl.org/sig/ont/fma/fma54973>)
      # Renal Pelvis
      (<http://purl.obolibrary.org/obo/UBERON_0001224> <http://purl.obolibrary.org/obo/UBERON_0018116>)
      (<http://purl.obolibrary.org/obo/UBERON_0001224> <http://purl.obolibrary.org/obo/UBERON_0018115>)
      # Ureter
      (<http://purl.obolibrary.org/obo/UBERON_0000056> <http://purl.obolibrary.org/obo/UBERON_0001223>)
      (<http://purl.obolibrary.org/obo/UBERON_0000056> <http://purl.obolibrary.org/obo/UBERON_0001222>)
    }
  }
  UNION
  {
    ?child ccf:ccf_part_of ?parent .
    FILTER(?parent != body:)
  }
  
  {
    ?child ccf:ccf_pref_label ?label1 .
  }
  UNION
  {
    [] a ?child, ccf:SpatialEntity ; skos:prefLabel ?label1 .
  }
  
  OPTIONAL {
    {
      ?child hasExactSynonym: ?synonymLabel1 .
    }
    UNION
    {
      ?child rdfs:label ?synonymLabel1 .
    }
  }

  BIND(IF(?child = ?root, 'body', STR(LCASE(?label1))) as ?label)
  BIND(STR(?synonymLabel1) as ?synonymLabel)
  BIND(IF(BOUND(?rank), ?rank, 1000) as ?rank_order)
}
ORDER BY ?rank_order ?label ?child
